import {  useState  } from 'react';
import { DEFAULT_RANGES } from '../../utils/constants';

interface RangeSelectorProps {
  range: {
    min: number;
    max: number;
  };
  setCustomRange: (range: { min: number; max: number }) => void;
}

export const RangeSelector: React.FC<RangeSelectorProps> = ({ range, setCustomRange }) => {
  const [minRange, setMinRange] = useState('1');
  const [maxRange, setMaxRange] = useState('10');

  const handleCustomRange = (e: React.FormEvent) => {
    e.preventDefault();
    const min = parseInt(minRange);
    const max = parseInt(maxRange);
    
    if (min > 0 && max > 0 && max <= 1000 && min <= max) {
      setCustomRange({ min, max });
    }
  };

  return (
    <div className="mb-8">
      <h3 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">Select Range</h3>
      <div className="flex flex-wrap gap-4 mb-4">
        {DEFAULT_RANGES.map((r) => (
          <button
            key={r}
            onClick={() => setCustomRange({ min: 1, max: r })}
            className={`px-4 py-2 rounded-lg transition-all ${
              range.max === r && range.min === 1
                ? 'bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-500 dark:to-purple-500 text-white font-medium'
                : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 font-medium'
            }`}
          >
            1 to {r}
          </button>
        ))}
      </div>
      
      <form onSubmit={handleCustomRange} className="flex gap-2">
        <div className="flex-1 grid grid-cols-2 gap-2">
          <input
            type="number"
            value={minRange}
            onChange={(e) => setMinRange(e.target.value)}
            placeholder="Min range"
            className="px-4 py-2 rounded-lg bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 border border-gray-200 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-colors"
            min="1"
            max="1000"
          />
          <input
            type="number"
            value={maxRange}
            onChange={(e) => setMaxRange(e.target.value)}
            placeholder="Max range"
            className="px-4 py-2 rounded-lg bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 border border-gray-200 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-colors"
            min="1"
            max="1000"
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 rounded-lg bg-indigo-600 dark:bg-indigo-500 text-white hover:bg-indigo-700 dark:hover:bg-indigo-600 transition-colors whitespace-nowrap font-medium"
        >
          Set Range
        </button>
      </form>
    </div>
  );
};